export type EffectiveBrand = {
  name: string;
  tenantSlug: string | null;
  primaryColor: string;
  accentColor: string;
  tagline: string;
  logoUrl: string | null;
  supportEmail: string;
  footerText: string;
};

export type PortalKey = "parent" | "student" | "school_admin" | "merchant";

export type DemoCredential = {
  portal: PortalKey;
  email: string;
  password: string;
  label: string;
  role: string;
};

export const ALL_PORTAL_KEYS: PortalKey[] = ["parent", "student", "school_admin", "merchant"];

export const TOGGLEABLE_MODULE_KEYS = ["health", "transport", "merchants", "procurement", "finance"] as const;

export type TenantBranding = {
  id: string;
  slug: string;
  name: string;
  primary_color: string;
  accent_color: string;
  tagline: string | null;
  logo_url: string | null;
  support_email: string | null;
  footer_text: string | null;
  custom_domains: string[] | null;
  domain: string | null;
  is_published: boolean;
  feature_prefix: string | null;
  hero_image_url: string | null;
  hero_headline: string | null;
  hero_subtitle: string | null;
  hero_eyebrow: string | null;
  modules_json: any;
  pricing_json: any;
  module_graphics_json: any;
  seo_title: string | null;
  seo_description: string | null;
  descriptor: string | null;
  updated_at: string | null;
  [key: string]: any;
};

const DEFAULT_BRAND: EffectiveBrand = {
  name: "BRECCS",
  tenantSlug: "breccs",
  primaryColor: "#145C4A",
  accentColor: "#C9A45C",
  tagline: "The operating infrastructure behind every school.",
  logoUrl: "/fpay.jpeg",
  supportEmail: "support@breccs.co.zw",
  footerText: "BRECCS Zimbabwe · Harare, Zimbabwe",
};

export function useEffectiveBrand() {
  return { brand: DEFAULT_BRAND };
}

export async function listTenantBrandings(): Promise<TenantBranding[]> {
  return [];
}

export async function upsertTenantBranding(_row: Partial<TenantBranding>): Promise<TenantBranding | null> {
  return null;
}

export async function uploadBrandAsset(_file: File, _slug: string): Promise<string | null> {
  return null;
}

export async function fetchTenantBranding(_slug: string): Promise<TenantBranding | null> {
  return null;
}

export function toEffective(row: TenantBranding): EffectiveBrand {
  return {
    name: row.name,
    tenantSlug: row.slug,
    primaryColor: row.primary_color,
    accentColor: row.accent_color,
    tagline: row.tagline ?? DEFAULT_BRAND.tagline,
    logoUrl: row.logo_url,
    supportEmail: row.support_email ?? DEFAULT_BRAND.supportEmail,
    footerText: row.footer_text ?? DEFAULT_BRAND.footerText,
  };
}

export function applyBrandCss(_brand: EffectiveBrand): void {}

export { DEFAULT_BRAND };
